<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">약속상품 신규 등록</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span class="emp">약속상품명</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.promise_goods_nm">
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">상품이미지</span></th>
                  <td>
                    <div class="form_inline">
                        <button class="btn btn_md btn_blue" @click="fn_goodsFileUpload">파일업로드</button>
                        <input type="file" ref="goodsFile" @change="fn_fileGoodsChange" hidden>
                        <ul class="file_list" v-if="regData.goods_file_nm != ''">
                            <li>{{regData.goods_file_nm}}</li>
                        </ul>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">출전</span></th>
                  <td>
                      <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.promise_goods_source">
                  </td>
                </tr>                
                <tr>
                  <th><span class="emp">상품타입</span></th>
                  <td>
                    <div class="form_select"> 
                      <b-form-select v-model="regData.promise_goods_type">
                        <b-form-select-option :value="null">선택</b-form-select-option>
                        <b-form-select-option v-for="(item, index) in goodsTypeList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                      </b-form-select>
                    </div>              
                  </td>
                </tr>        
                <!-- <tr>
                  <th><span class="emp">약재</span></th>
                  <td>
                    <div class="table_list">
                      <div class="table_option">
                        <div class="form_select"></div>
                        <button class="btn btn_md btn_blue" v-b-modal.searchModal>추가</button>
                      </div>
                      <table class="list no_view">
                        <colgroup>
                          <col width="100">
                          <col width="100">
                          <col width="100">
                          <col width="100">
                          <col width="100">
                        </colgroup>
                        <thead>
                          <tr>
                            <th v-for="(th, index) in smallTableHead" :key="index">{{th.head}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(td, index) in smallTableData" :key="index">
                            <td><span>{{ td.name }}</span></td>
                            <td><span>{{ td.country }}</span></td>
                            <td>
                              <input type="text" class="form_control xl_limit">
                              <span>g</span>
                            </td>
                            <td><span>{{ td.price }}</span></td>
                            <td><button class="icon icon_del"></button></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>                     -->
                <!-- <tr>
                  <th><span class="emp">구성수량</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.promise_goods_quantity">
                  </td>
                </tr>                            -->
                <tr>
                  <th><span class="emp">조제단위</span></th>
                  <td>
                    <div class="form_select">
                      <b-form-select v-model="regData.prepare_unit">
                        <b-form-select-option :value="null">선택</b-form-select-option>
                        <b-form-select-option v-for="(item, index) in packageUnitList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                      </b-form-select>
                    </div>              
                  </td>
                </tr>                 
                <tr>
                  <th><span>구성안내</span></th>
                  <td>
                    <textarea class="form_control" style="line-height: 20px;" v-model="regData.component_descript"></textarea>
                  </td>
                </tr> 
                <!-- <tr>
                  <th><span class="emp">처방비용</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.promise_goods_price">
                  </td>
                </tr>  -->
                <!-- <tr>
                  <th><span class="emp">배송비용</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요.">
                  </td>
                </tr>  -->
                <!-- <tr>
                  <th><span>복용법</span></th>
                  <td>
                    <textarea class="form_control" placeholder="입력해주세요."></textarea>
                  </td>
                </tr>  -->
                <tr>
                  <th><span class="emp">상품노출여부</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio" id="radio1" name="radio" value="Y" v-model="regData.display_yn">
                        <label for="radio1">Y</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="radio2" name="radio" value="N" v-model="regData.display_yn">
                        <label for="radio2">N</label>
                      </div>
                    </div>                   
                  </td>
                </tr>                 
                <tr>
                  <th><span>기준재고량</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.stdr_invt_qy">
                  </td>
                </tr>    
                <!-- <tr>
                  <th><span class="emp">상세정보 입력방식</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio" id="sel1" name="select" 
                          @change="isEditVisible = false, isImgVisible = true"  
                          checked
                        >
                        <label for="sel1">이미지 </label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="sel2" name="select" 
                          @change="isImgVisible = false, isEditVisible = true"  
                        >
                        <label for="sel2">에디트박스 </label>
                      </div>
                    </div>                   
                  </td>
                </tr> -->
                <tr>
                  <th><span class="emp">상세정보 이미지</span></th>
                  <td>
                    <div class="form_inline">
                        <button class="btn btn_md btn_blue" @click="fn_goodsInfoFileUpload">파일업로드</button>
                        <input type="file" ref="goodsInfoFile" @change="fn_fileGoodsInfoChange" hidden>
                        <ul class="file_list" v-if="regData.goods_info_file_nm != ''">
                            <li>{{regData.goods_info_file_nm}}</li>
                        </ul>
                    </div>
                  </td>
                </tr>
                <!-- <tr v-else>
                  <th><span class="emp">상세정보</span></th>
                  <td>
                    <Editor/>
                  </td>
                </tr> -->
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline"  @click="fn_move_page">목록</button>
              <div class="btn_box">
                <!-- <button class="btn btn_md btn_gray">취소</button> -->
                <button class="btn btn_md btn_darkblue" @click="fn_reg_promise_goods">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <alert-modal 
            :id="'alert'"
            :text="showAlertMsg" 
            :btnRight="'확인'" 
            :oneBtn="false"
            :isShow="showAlert"
            :className="'btn_brown'"
            v-on:update:showSetting="fn_showSet"
        />
    </div>
</template>

<script>
  import axios from 'axios'
  import AlertModal from "@/modal/common/alertModal.vue"
  import commonUtil from "@/mixin/commonUtil";
  import alertutill from "@/mixin/alertModalUtill";

  export default {
    name: 'PromiseGoodsReg',
    mixins: [alertutill,commonUtil],
    components: {
      'alert-modal' : AlertModal,
    },
    data() {
      return {
        goodsTypeList : [],       // 상품타입 리스트
        packageUnitList : [],      // 포장단위 리스트
        regData : {
          promise_goods_cd : '',
          promise_goods_nm : '',
          promise_goods_type : null,
          promise_goods_source : '',
          //promise_goods_quantity : '',
          prepare_unit : null,
          component_descript : '',
          display_yn : 'Y',
          stdr_invt_qy : 0,
          goods_file_nm : '',
          goods_info_file_nm : '',
          //promise_goods_price : 0,
          status : ''
        },
        upLoadFile : {
            goods_file : '',
            goods_info_file : ''
        },
      }
    },
    async created(){
        //공통코드 - 상품타입가져오기
        this.goodsTypeList = await this.getCode('GC00000008');        
        
        //공통코드 - 조제단위가져오기
        this.packageUnitList = await this.getCode('GC00000009');  

        this.regData.status = this.$store.getters['promise/getStatus'];

        if(this.regData.status == 'M'){
          this.regData.promise_goods_cd = this.$store.getters['promise/getPromiseGoodsCd'];  
          this.fn_search(); 
        }

    },
    methods : {
      fn_goodsFileUpload(){
          let fileInputElement = this.$refs.goodsFile;
          fileInputElement.click();
      },
      fn_fileGoodsChange(e){
          this.upLoadFile.goods_file = e.target.files[0];
          this.regData.goods_file_nm = this.upLoadFile.goods_file.name;
      },
      fn_goodsInfoFileUpload(){
          let fileInputElement = this.$refs.goodsInfoFile;
          fileInputElement.click();
      },
      fn_fileGoodsInfoChange(e){
          this.upLoadFile.goods_info_file = e.target.files[0];
          this.regData.goods_info_file_nm = this.upLoadFile.goods_info_file.name;
      },
      fn_reg_promise_goods(){

        if(this.fn_validation_chk()){

            var frm = new FormData();
   
            frm.append("file",this.upLoadFile.goods_file);
            frm.append("file2",this.upLoadFile.goods_info_file);
            frm.append("key",JSON.stringify(this.regData));
            

            axios
                .post("/api/admin/promise/regPromiseGoodsWithFile", frm, {
                        "Content-Type": "multipart/form-data",
                        "Accept-Language" : "ko"})
                .then((res) => {                            
                    console.log("@@@@ res : %o",res);
                    if(res.data.result == "ok"){
                        // let msg = "저장되었습니다";
                        // this.fn_open_alert(msg);
                        alert("저장되었습니다.");
                        this.fn_move_page();  
                    }else{
                        let msg = res.data.errorMsg;
                        this.fn_open_alert(msg);
                    } 
                    
                })
                .catch((err) => console.log(err));
        }
        
      },
      fn_validation_chk(){
        if(this.regData.promise_goods_nm == ''){
            alert("약속상품을 입력해주세요");    
            return false;
        }

        if(this.regData.goods_file_nm == ''){
            alert("상품이미지를 선택해주세요");    
            return false;
        }

        if(this.regData.promise_goods_type == null){
            alert("상품타입를 선택해주세요");    
            return false;
        }

        // if(this.regData.promise_goods_quantity == ''){
        //     alert("상품수량을 선택해주세요");    
        //     return false;
        // }

        if(this.regData.prepare_unit == ''){
            alert("제조단위를 선택해주세요");    
            return false;
        }

        // if(this.regData.promise_goods_price <= 0 || this.regData.promise_goods_price == ''){
        //     alert("약속상품가격을 입력해주세요");    
        //     return false;
        // }

        if(this.regData.goods_info_file_nm == ''){
            alert("상품정보이미지를 선택해주세요");    
            return false;
        }

        return true;
      },
      fn_move_page(){
            this.$router.push("/admin/promise/promiseGoodsMngt");
      },
      fn_search(){

        let param = new Object();
        param.promise_goods_cd = this.regData.promise_goods_cd;

        console.log("@@@@ param : %o",param);

        axios
            .post("/api/admin/promise/promiseGoodsDetail", param)
            .then((res) => {
                console.log("@@@@ dtl res : %o",res);
              
                this.regData.promise_goods_nm = res.data.promise_goods_nm;
                this.regData.promise_goods_source = res.data.promise_goods_source;
                this.regData.promise_goods_type = res.data.promise_goods_type;
                this.regData.promise_goods_quantity = res.data.promise_goods_quantity;
                this.regData.prepare_unit = res.data.prepare_unit;
                this.regData.component_descript = res.data.component_descript;
                this.regData.display_yn = res.data.display_yn;
                this.regData.stdr_invt_qy = res.data.stdr_invt_qy;
                this.regData.goods_file_id = res.data.goods_file_id;
                this.regData.goods_info_file_id = res.data.goods_info_file_id;
                this.regData.promise_goods_price = res.data.promise_goods_price;
                this.regData.goods_file_nm = res.data.goods_file_nm;
                this.regData.goods_info_file_nm = res.data.goods_info_file_nm;
            })
            .catch((err) => console.log(err));
              
      },
    }
  }
</script>